module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', [_c('v-col', {
    staticClass: "pb-5",
    attrs: {
      "cols": "7"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "d-flex align-center justify-center",
    staticStyle: {
      "height": "180px"
    }
  }, [_c('v-progress-linear', {
    staticStyle: {
      "width": "200px !important"
    },
    attrs: {
      "indeterminate": "",
      "color": "blew",
      "rounded": "",
      "height": "6"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-5",
    attrs: {
      "cols": "5"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "d-flex align-center justify-center",
    staticStyle: {
      "height": "180px"
    }
  }, [_c('v-progress-linear', {
    staticStyle: {
      "width": "200px !important"
    },
    attrs: {
      "indeterminate": "",
      "color": "blew",
      "rounded": "",
      "height": "6"
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a3a545e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Konsul/components/LoadingChart.vue
// module id = 1602
// module chunks = 1